export default __webpack_public_path__ + "static/media/telephone.2b82044d.svg";